import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {GoogleMapsComponent} from './components/google-maps/google-maps.component';
import {DataConverterComponent} from './components/data-converter/data-converter.component';
import {SvgMapComponent} from './components/svg-map/svg-map.component';
import {Routenames} from './routenames';
import {LinkLoginComponent} from './components/auth/link-login/link-login.component';
import {IsAuthenticated} from './is-authenticated';
import {LogoutComponent} from './components/auth/logout/logout.component';
import {IsNotAuthenticated} from './is-not-authenticated';
import {EntitiesComponent} from './components/entities/entities.component';
import {WorkordersComponent} from './components/workorders/workorders.component';
import {UsersComponent} from './components/users/users.component';
import {UserEditComponent} from './components/user-edit/user-edit.component';
import {AuthRolesComponent} from './components/auth/auth-roles/auth-roles.component';
import {ProjectsMapComponent} from './components/projects-map/projects-map.component';
import {DrawingsComponent} from './components/drawings/drawings.component';
import {TtmTicketsComponent} from './components/ttm-tickets/ttm-tickets.component';
import {NotDefinedRouteComponent} from './not-defined-route-component';
import {CanDeactivate} from './can-deactivate';
import {ExportInterfaceComponent} from './components/export-interface/export-interface.component';
import { UserInsightComponent } from './components/user-insight/user-insight.component';
import { TtmTicketDetailComponent } from './components/ttm-ticket-detail/ttm-ticket-detail.component';
import { WorkorderImagesComponent } from './components/workorder-images/workorder-images.component';

const routes: Routes = [
    {path: Routenames.Login + '/:token', component: LinkLoginComponent},
    {path: Routenames.Login, component: LinkLoginComponent},
    {path: Routenames.Logout, component: LogoutComponent},
    {path: 'convert/:id', component: DataConverterComponent, canActivate: [IsAuthenticated]},
    {path: 'convert', component: DataConverterComponent, canActivate: [IsAuthenticated]},
    {path: 'svg/:file', component: SvgMapComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.Users + '/:id', component: UserEditComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.Users, component: UsersComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.TtmTickets, component: TtmTicketsComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.TtmTickets + '/:ticketId', component: TtmTicketDetailComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.Projects + '/' + Routenames.Map, component: ProjectsMapComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.Projects + '/:projectId', component: GoogleMapsComponent, canActivate: [IsAuthenticated], canDeactivate: [CanDeactivate]},
    {path: Routenames.Drawings, component: DrawingsComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.AuthMatrix, component: AuthRolesComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.WorkOrders, component: WorkordersComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.WorkOrderImages, component: WorkorderImagesComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.ExportInterface, component: ExportInterfaceComponent, canActivate: [IsAuthenticated]},
    {path: 'entities', component: EntitiesComponent, canActivate: [IsAuthenticated]},
    {path: 'entities/:skip', component: EntitiesComponent, canActivate: [IsAuthenticated]},
    {path: Routenames.UserInsight, component: UserInsightComponent, canActivate: [IsAuthenticated]},
    {path: '**', component: NotDefinedRouteComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        initialNavigation: 'disabled'
    })],
    exports: [RouterModule],
    providers: [IsAuthenticated, IsNotAuthenticated]
})
export class AppRoutingModule {
}
